<template>
  <div>
    <p class="check-mic-tips">{{ $t("check.pleasespeaktomic") }}</p>
    <div v-if="errors" class="error_message" style="text-align:left;margin-left: 70px;">{{ message }}</div>
    <el-select
      v-model="audioInputDeviceId"
      :popper-append-to-body="false"
      class="check-select-device"
      :no-data-text="$t('checkCamera.无设备')"
    >
      <el-option
        v-for="item in audioDeviceList"
        :key="item.value"
        :label="item.label"
        :value="item.deviceId"
        @click.native="changeTrack(item.deviceId)"
      >
      </el-option>
    </el-select>
    <!-- 进度条 -->
    <ul class="check-process">
      <li
        v-for="(p, i) in processList"
        :key="i"
        :class="{ 'check-process-active': !!p }"
      ></li>
    </ul>
    <!-- 滑块 -->
    <div class="check-slider">
      <!-- <img :src="require('@/svg/mic1.svg')" width="16" /> -->
      <svg width="16px" height="20px" viewBox="0 0 16 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>入会检测切图</title>
        <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="入会检测切图" transform="translate(-400.000000, -232.000000)" class="more-chat" fill="#FFFFFF" fill-rule="nonzero">
                <g id="编组-4" transform="translate(400.000000, 232.000000)">
                    <g id="麦克风" transform="translate(1.322595, 0.234375)">
                        <path d="M6.67740463,0 C8.80499813,0 10.5297534,1.78863514 10.5297534,3.9950284 L10.5297534,8.43394886 C10.5297534,10.6403421 8.80499813,12.4289773 6.67740463,12.4289773 C4.54981113,12.4289773 2.82505581,10.6403421 2.82505581,8.43394886 L2.82505581,3.9950284 C2.82505581,1.78863514 4.54981113,0 6.67740463,0 Z M6.67740463,1.42045454 C5.30628881,1.42045454 4.19477983,2.57313052 4.19477983,3.9950284 L4.19477983,8.43394886 C4.19477983,9.35376114 4.66795552,10.2037063 5.43608565,10.6636149 C6.20421578,11.1235235 7.15059348,11.1235235 7.9187236,10.6636149 C8.68685373,10.2037063 9.16002942,9.35376114 9.16002942,8.43394886 L9.16002942,3.9950284 C9.16002942,2.57313052 8.04852044,1.42045454 6.67740463,1.42045454 Z" id="形状"></path>
                        <path d="M0,8.8778409 C0,12.7022559 2.98957589,15.8025568 6.67740463,15.8025568 C10.3652334,15.8025568 13.3548093,12.7022559 13.3548093,8.8778409 C13.3548093,8.62407324 13.2243245,8.38956435 13.0124108,8.26266843 C12.8004972,8.13577252 12.5393972,8.13577252 12.3274836,8.26266843 C12.11557,8.38956435 11.9850449,8.62407324 11.9850852,8.8778409 C11.9850668,11.917747 9.60874266,14.3820677 6.67740463,14.3820677 C3.74606659,14.3820677 1.36974244,11.917747 1.36972403,8.8778409 C1.36976416,8.6240734 1.23923897,8.38956475 1.02732545,8.26266898 C0.815411925,8.13577322 0.554312114,8.13577322 0.342398591,8.26266898 C0.130485069,8.38956475 0,8.6240734 0,8.8778409 Z" id="路径"></path>
                        <path d="M5.99254261,15.0923295 L5.99254261,17.9536577 C5.99254261,18.2073974 6.12307656,18.4418627 6.33497361,18.5687326 C6.54687066,18.6956024 6.8079386,18.6956024 7.01983565,18.5687326 C7.2317327,18.4418627 7.36226665,18.2073974 7.36226665,17.9536577 L7.36226665,15.0923295 C7.36226665,14.7000818 7.05564348,14.3821023 6.67740463,14.3821023 C6.29916578,14.3821023 5.99254261,14.7000818 5.99254261,15.0923295 L5.99254261,15.0923295 Z" id="路径"></path>
                        <path d="M4.53721084,19.3536932 L8.86639483,19.3536932 C9.11109921,19.3537348 9.33723255,19.2183753 9.45959632,18.9986132 C9.5819601,18.778851 9.5819601,18.5080808 9.45959632,18.2883187 C9.33723255,18.0685565 9.11109921,17.933197 8.86639483,17.9332386 L4.53721084,17.9332386 C4.29250647,17.933197 4.06637313,18.0685565 3.94400935,18.2883187 C3.82164558,18.5080808 3.82164558,18.778851 3.94400935,18.9986132 C4.06637313,19.2183753 4.29250647,19.3537348 4.53721084,19.3536932 L4.53721084,19.3536932 Z" id="路径"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
      <div class="check-slider-inner">
        <el-slider
          v-model="processNum"
          :min="1"
          class="check-slider-number"
        ></el-slider>
      </div>
      <span class="fontColor">{{ processNum }}</span>
    </div>
    <p class="mic-tips fontColor">
      {{$t('checkCamera.请确认是否看到音量条波动')}}
    </p>
  </div>
</template>

<script>
import { Slider } from "element-ui";
import mediaError from "@/mixins/mediaAudioError";
export default {
  name: "checkMic",
  data() {
    return {
      audioDeviceList: [],
      audioInputDeviceId: null,
      audioStream: null,
      inputInstant: null,
      mic: null,
      context: null,
      script: null,
      processList: [],
      processNum: 5,
      isLoadAudioStream: false,
    };
  },
  components: {
    [Slider.name]: Slider,
  },
  mixins: [mediaError],
  computed: {
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    publishLocal() {
      let publishLocal = null;
      if (
        this.rtcClient &&
        this.rtcClient.RTCRoom &&
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal
      ) {
        publishLocal = this.rtcClient.RTCRoom.webrtc.publishLocal;
      }
      return publishLocal;
    },
    webrtc() {
      let webrtc = null;
      if (
        this.rtcClient &&
        this.rtcClient.RTCRoom &&
        this.rtcClient.RTCRoom.webrtc
      ) {
        webrtc = this.rtcClient.RTCRoom.webrtc;
      }
      return webrtc;
    },
  },
  watch: {
    publishLocal: {
      deep: true,
      handler(val) {
        if (
          this.publishLocal &&
          this.publishLocal.errInfo &&
          this.publishLocal.errInfo.audio &&
          this.publishLocal.errInfo.audio.code == 1
        ) {
          this.audioDeviceList.push({
            label: this.$t("check.nomicdevice"),
            deviceId: null,
          });
          this.audioInputDeviceId = null;
          this.$store.commit("SET_AUDIOINPUTDEVICEID", this.audioInputDeviceId);
        }
        if (val.publishStream && !this.isLoadVideoStream) {
          this.init();
        }
      },
    },
  },
  created() {
    if (
      this.publishLocal &&
      this.publishLocal.publishStream &&
      !this.isLoadVideoStream
    ) {
      this.init();
    }
  },
  beforeDestroy() {
    // this.stopAudioTrack();
    this.stopAudioContext();
  },
  methods: {
    async init() {
      this.isLoadAudioStream = true;
      await this.setAudioDevice();
      this.processList = [];
      let deviceInfos = await navigator.mediaDevices.enumerateDevices();
      this.audioDeviceList = deviceInfos.filter((d) => {
        return d.kind === "audioinput" && d.deviceId;
      });
      if (!this.audioStream || this.audioDeviceList.length == 0) {
        this.audioDeviceList.push({
          label: this.$t("check.nomicdevice"),
          deviceId: null,
        });
        this.audioInputDeviceId = null;
      } else {
        var audioDeviceId = this.audioStream
          .getAudioTracks()[0]
          .getSettings().deviceId;
        var curSelectAudioInput = this.audioDeviceList.find((AudioInput) => {
          return audioDeviceId == AudioInput.deviceId;
        });
        this.audioInputDeviceId = curSelectAudioInput
          ? curSelectAudioInput.deviceId
          : "";
      }
      this.$store.commit("SET_AUDIOINPUTDEVICEID", this.audioInputDeviceId);
      for (let i = 0; i < 20; i++) {
        this.processList.push(false);
      }
    },
    async setAudioDevice() {
      // if (this.audioInputDeviceId != -1) {
      // this.stopAudioTrack();
      // const audioInputDeviceId =
      //   this.audioInputDeviceId != "-1" ? this.audioInputDeviceId : true;
      // const stream = await navigator.mediaDevices
      //   .getUserMedia({
      //     audio: { deviceId: audioInputDeviceId },
      //   })
      //   .catch((err) => {
      //     return err;
      //   });
      // if (stream.id) {
      //   this.audioStream = stream;
      //   this.getProcess();
      //   this.$store.commit("SET_AUDIOINPUTDEVICEID", this.audioInputDeviceId);
      // }
      // } else {
      //   this.$store.commit("SET_AUDIONPUTDEVICEID", false);
      // }
      this.audioStream = this.publishLocal.publishStream;
      if(this.publishLocal.errInfo.audio){
        this.getUserMediaError(this.publishLocal.errInfo.audio.info.name);
      }else{
        this.getUserMediaError("success");
        this.getProcess();
      }
    },
    async changeTrack(deviceId) {
      let publishStream = await this.webrtc.createVideoorAudioStream(
        deviceId,
        "audio",
        "changeDevice"
      );
      if (publishStream && publishStream.code == 1) {
        this.$alert(this.$t('checkMic.切换失败'));
      } else {
        this.audioStream = this.publishLocal.publishStream;
        this.getProcess();
        this.$store.commit("SET_AUDIOINPUTDEVICEID", deviceId);
      }
    },
    stopAudioTrack() {
      if (this.audioStream) {
        console.log(this.audioStream);
        for (let i = 0; i < this.audioStream.getAudioTracks().length; i++) {
          this.audioStream.getAudioTracks()[i].stop();
        }
        this.audioStream = null;
      }
    },
    getProcess() {
      this.stopAudioContext();
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      this.context = new AudioContext();
      this.mic = this.context.createMediaStreamSource(this.audioStream);
      this.script = this.context.createScriptProcessor(2048, 1, 1);
      this.mic.connect(this.script);
      this.script.connect(this.context.destination);
      this.script.onaudioprocess = (event) => {
        const input = event.inputBuffer.getChannelData(0);
        let inputsum = 0.0;
        for (let i = 0; i < input.length; ++i) {
          inputsum += input[i] * input[i] * this.processNum;
        }
        this.inputInstant = parseInt(Math.sqrt(inputsum / input.length) * 100);
        this.setProcessList();
        console.log(1);
      };
    },
    setProcessList() {
      let isActive = parseInt(this.inputInstant / 5);
      this.processList = [];
      for (let i = 0; i < 20; i++) {
        if (i < isActive) {
          this.processList.push(true);
        } else {
          this.processList.push(false);
        }
      }
    },
    stopAudioContext() {
      if (this.mic) {
        this.mic.disconnect();
        this.mic = null;
      }
      if (this.script) {
        this.script.disconnect();
        this.script = null;
      }
    },
  },
};
</script>

<style lang="scss">
.check-mic-tips {
  position: absolute;
  top: 10px;
  color: $white-color;
  left: 70px;
  font-size: 12px;
}
.mic-tips{
  color: $white-color;
  font-size: 12px;
  text-align: left;
  margin-left: 80px;
}
body {.check-process {
  width: 240px;
  display: flex;
  justify-content: space-around;
  margin: 30px 0px 0px 70px;
  li {
    display: inline-block;
    width: 6px;
    height: 16px;
    border-radius: 3px;
    background-color: $purple-color;
  }
  .check-process-active {
    background-color: $green-color !important;
  }
}
}
.check-slider {
  width: 240px;
  margin: 20px 0px 0px 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $white-color;
  .check-slider-number {
    width: 180px;
    margin: 0 auto;
  }
  > span {
    width: 20px;
  }
  &-inner {
    flex: 1;
    min-width: 0;
  }
}
</style>
